import React from 'react';
import { useTheme } from '@theme/useTheme';

interface GradientBackgroundProps {
  position?: 'top' | 'bottom';
  height?: 'small' | 'medium' | 'large';
  className?: string;
}

const GradientBackground: React.FC<GradientBackgroundProps> = ({
  position = 'top',
  height = 'large',
  className = ''
}) => {
  const { mode } = useTheme();

  // Don't render gradient background in dark mode
  if (mode === 'dark') {
    return null;
  }
  const getHeightClass = () => {
    switch (height) {
      case 'small':
        return 'h-1/4';
      case 'medium':
        return 'h-1/2';
      case 'large':
        return 'h-3/4';
      default:
        return 'h-1/2';
    }
  };

  const getPositionClass = () => {
    return position === 'top' ? 'top-0' : 'bottom-0';
  };

  return (
    <div
      className={`absolute ${getPositionClass()} left-0 right-0 ${getHeightClass()} ${className}`}
      style={{
        animation: position === 'top'
          ? 'colorCycle 15s ease-in-out infinite'
          : 'colorCycleBottom 15s ease-in-out infinite'
      }}
    />
  );
};

export default GradientBackground;
